import React from 'react'

const FeatItem = () => {
    return (
        <div className="_profile_details_main_content">
            <div className="_profile_details_main_content_txt">
                <h2 className="_profile_details_main_content_title text-center">
                    Featured Items
                </h2>
            </div>
            <div className="_profile_details_main_content_input_wrap">
                <div className="row align-content-center my-3">
                    {
                        Array.from(Array(8), (item, id) => 
                            <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12" key={id}>
                                <div className="_profile_details_feat_content">
                                    <h4 className="_profile_details_feat_content_title">
                                        {id+1}
                                    </h4>
                                    <button className="_profile_details_feat_content_btn">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="none" viewBox="0 0 35 35">
                                            <path stroke="#fff" stroke-linecap="round" stroke-width="2.917" d="M17.5 29.167V17.5m0 0V5.834m0 11.666h11.666m-11.666 0H5.833" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default FeatItem